$(function(){
	$('#js-nav-scroll a[href^="#"]').click(function () {
		var speed = 700;
		var href = $(this).attr('href');
		var target = $(href == '#' || href == '' ? 'html' : href);
		var position = target.offset().top - 100;
		$('html, body').animate({ scrollTop: position }, speed, 'swing');
		return false;
	});

	if($(window).width() < 897){
		$('#gHeader .searchBox').insertAfter($('#gHeader .hBox'));

		$("#gHeader .searchBtn a").click(function(){
			$(this).toggleClass("on");
			$("#gHeader .searchBox").stop().slideToggle(300);
			return false;
		});
	}

	var pcflag,spflag;
	if(window.innerWidth > 896){
		pcflag = 1;
		spflag = 0;
	}else{
		pcflag = 0;
		spflag = 1;
	}

	$(window).resize(function(){
		if(window.innerWidth <= 896){
			if(pcflag){
				setTimeout(function(){window.location.reload()},100);
				pcflag = 0;
				spflag = 1;
			}
		}else{
			if(spflag){
				setTimeout(function(){window.location.reload()},100);
				pcflag = 1;
				spflag = 0;
			}
		}
	});

	var state = false;
	var scrollpos;

	$('.menu').on('click', function(){
		if(state == false) {
			scrollpos = $(window).scrollTop();
			$('body').addClass('fixed').css({'top': -scrollpos});
			state = true;
		} else {
			$('body').removeClass('fixed').css({'top': 0});
			window.scrollTo( 0 , scrollpos );
			state = false;
		}

		$('.menuBox').toggleClass('on');
		$('.menu').toggleClass('close');

		return false;
	});

	$('.popup-modal').magnificPopup({
		midClick: true,
		mainClass: 'mfp-fade mfp-type',
		removalDelay: 150,
		showCloseBtn: false,
		callbacks: {
			open: function() {
				if(state == false) {
					scrollpos = $(window).scrollTop();
					$('body').addClass('fixed').css({'top': -scrollpos});
					state = true;
				}
			},
			close: function(){
				$('body').removeClass('fixed').css({'top': 0});
				window.scrollTo( 0 , scrollpos );
				$('body').removeClass('fixed');
				state = false;
			}
		}
	})

	$('.popup-modal-close').click(function (e) {
		e.preventDefault();
		$.magnificPopup.close();
		return false;
	});
});

$(window).on('load',function(){
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){
		localLink = localLink.slice(localLink.indexOf("#")+1);
		$('html,body').animate({scrollTop: $('#'+localLink).offset().top}, 500);
	}
});

